module.exports = __webpack_public_path__ + "img/pifu.23871469.png";